module.exports = __webpack_public_path__ + "static/szfy-c21c8acce56663eefc791c40854db509.jpg";